import {createGlobalStyle} from 'styled-components';
import reset from 'styled-reset';

const globalStyle = createGlobalStyle`
    ${reset}
    a {
        text-decoration: none;
        color: inherit;
    }
    
    * {
        box-sizing: border-box;
    }

    body {
        width:100%;
        height: 100vh;
        font-family: --apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        font-size: 12px;
        background-color: rgba(20,20,20,1);
        color:white;
    }
`

export default globalStyle;